import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menuContainer", "backdrop", "menu", "closeButton"]

  connect() {
    this.isOpen = false
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true
    
    // Enable pointer events on container
    this.menuContainerTarget.classList.remove("pointer-events-none")
    this.menuContainerTarget.classList.add("pointer-events-auto")
    
    // Fade in backdrop
    this.backdropTarget.classList.remove("opacity-0")
    this.backdropTarget.classList.add("opacity-100")
    
    // Slide in menu
    this.menuTarget.classList.remove("-translate-x-full")
    this.menuTarget.classList.add("translate-x-0")
    
    // Show close button
    this.closeButtonTarget.classList.remove("hidden")
    
    // Prevent body scroll
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.isOpen = false
    
    // Disable pointer events on container
    this.menuContainerTarget.classList.remove("pointer-events-auto")
    this.menuContainerTarget.classList.add("pointer-events-none")
    
    // Fade out backdrop
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")
    
    // Slide out menu
    this.menuTarget.classList.remove("translate-x-0")
    this.menuTarget.classList.add("-translate-x-full")
    
    // Hide close button
    this.closeButtonTarget.classList.add("hidden")
    
    // Re-enable body scroll
    document.body.classList.remove("overflow-hidden")
  }

  // Close when clicking on the backdrop
  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }
}

